import DOMPurify from 'dompurify'

const SANITIZE_OPTIONS = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['iframe', 'object', 'embed', 'script', 'style', 'link', 'meta'],
  RETURN_TRUSTED_TYPE: false
}

function normalizeHtml(html) {
  return String(html ?? '')
}

export function sanitizeHtmlFragment(html = '') {
  return DOMPurify.sanitize(normalizeHtml(html), SANITIZE_OPTIONS)
}

export function setSafeHtml(element, html) {
  if (!element) return
  element.innerHTML = sanitizeHtmlFragment(html)
}
